// Regra da senha do candidato (a mesma do servidor, Validacoes.SenhaCandidato): de 6 a 25 caracteres, com pelo menos 1 letra
// e 1 número. Embaixo do campo, a lista dos critérios marca cada um enquanto a pessoa digita. Serve à v2 (classes ent__crit)
// e às telas de hoje (classes do Bootstrap, passadas em `classes`); os textos vêm da página (resx).
const CRITERIOS = [
    ['tamanho', v => v.length >= 6 && v.length <= 25],
    ['letra', v => /\p{L}/u.test(v)],
    ['numero', v => /\d/.test(v)]
];

const ICONE = {
    ok: 'M16 8A8 8 0 1 1 0 8a8 8 0 0 1 16 0m-3.97-3.03a.75.75 0 0 0-1.08.022L7.477 9.417 5.384 7.323a.75.75 0 0 0-1.06 1.06L6.97 11.03a.75.75 0 0 0 1.079-.02l3.992-4.99a.75.75 0 0 0-.01-1.05z',
    falta: 'M2 8a.5.5 0 0 1 .5-.5h11a.5.5 0 0 1 0 1h-11A.5.5 0 0 1 2 8'
};

export const senhaValida = valor => CRITERIOS.every(([, atende]) => atende(valor || ''));

// As regras dos outros campos do candidato (as do servidor, Validacoes.cs), para o cadastro, as telas de passagem e o Meu
// currículo mostrarem o erro antes do envio. Nome: Validacoes.NomePessoa (6 a 70 caracteres, com sobrenome, só letras,
// apóstrofo e hífen, sem palavra de uma letra só repetida). O apóstrofo tipográfico (iPhone) vira o comum.
export const nomeLimpo = v => (v || '').trim().replace(/\s+/g, ' ').replace(/[‘’ʼ´`]/g, "'").normalize('NFC');
export const nomeValido = nome => nome.length >= 6 && nome.length <= 70 && nome.includes(' ') && /^[\p{L}' -]+$/u.test(nome)
    && !nome.toLowerCase().split(' ').some(p => p.length > 2 && /^(.)\1*$/u.test(p));
// E-mail (Validacoes.Email). O do login fica mais solto: aceita o e-mail antigo como está gravado.
export const emailNovoValido = v => /^[a-z0-9!#$%&'*+/=?^_`{|}~-]+(?:\.[a-z0-9!#$%&'*+/=?^_`{|}~-]+)*@(?:[a-z0-9](?:[a-z0-9-]*[a-z0-9])?\.)+[a-z0-9](?:[a-z0-9-]*[a-z0-9])?$/i.test(v);
// Celular e telefone do Brasil (Validacoes.Telefone): DDD que existe; celular com 9 e mais 8 (sem 90), fixo de 2 a 5 e mais 7.
export const foneBrValido = v => /^(?:[14689][1-9]|2[12478]|3[1234578]|5[1345]|7[134579])(?:[2-5]\d{3}|9[1-9]\d{3})\d{4}$/.test(String(v || '').replace(/\D/g, ''));

// Domínio digitado errado no e-mail. Os provedores mais usados no Brasil, os domínios que não existem e são digitados no lugar
// deles, e os erros de digitação do final (.con, .com.vr, vírgula no lugar do ponto, final esquecido).
const DOMINIOS = ['gmail.com', 'hotmail.com', 'hotmail.com.br', 'outlook.com', 'outlook.com.br', 'live.com', 'live.com.br', 'msn.com', 'yahoo.com', 'yahoo.com.br', 'icloud.com', 'me.com', 'bol.com.br', 'uol.com.br', 'terra.com.br', 'ig.com.br', 'globo.com', 'globomail.com', 'r7.com', 'zipmail.com.br', 'aol.com', 'protonmail.com', 'proton.me'];
const TROCAS = { 'gmail.com.br': 'gmail.com', 'icloud.com.br': 'icloud.com', 'bol.com': 'bol.com.br', 'uol.com': 'uol.com.br', 'terra.com': 'terra.com.br', 'ig.com': 'ig.com.br' };

function _distancia(a, b) {
    const d = Array.from({ length: a.length + 1 }, (_, i) => [i]);
    for (let j = 1; j <= b.length; j++) {
        d[0][j] = j;
    }
    for (let i = 1; i <= a.length; i++) {
        for (let j = 1; j <= b.length; j++) {
            d[i][j] = Math.min(d[i - 1][j] + 1, d[i][j - 1] + 1, d[i - 1][j - 1] + (a[i - 1] === b[j - 1] ? 0 : 1));
        }
    }
    return d[a.length][b.length];
}

export function sugerirEmail(email) {
    const v = (email || '').trim().toLowerCase();
    const i = v.lastIndexOf('@');
    if (i < 1 || v.indexOf('@') !== i) {
        return '';
    }
    const local = v.slice(0, i);
    const digitado = v.slice(i + 1);
    let dominio = digitado.replace(/,/g, '.').replace(/\.{2,}/g, '.').replace(/^\.+|\.+$/g, '')
        .replace(/\.(con|cmo|cpm|vom|xom|cim|clm|ocm|comm|coom|om)$/, '.com')
        .replace(/\.(con|cmo|cpm|vom|xom|cim|com)\.?(br|vr|bt|be|brr)$/, '.com.br')
        .replace(/combr$/, '.com.br');
    if (!dominio) {
        return '';
    }
    if (TROCAS[dominio]) {
        dominio = TROCAS[dominio];
    } else if (!dominio.includes('.')) {
        // Final esquecido ("gmail", "hotmial"): o provedor mais parecido, pelo nome.
        const tolera = dominio.length > 5 ? 2 : dominio.length > 3 ? 1 : 0;
        dominio = DOMINIOS.find(d => _distancia(dominio, d.split('.')[0]) <= tolera) || dominio;
    } else if (!DOMINIOS.includes(dominio) && dominio.length > 4) {
        let menor = 3;
        DOMINIOS.forEach(d => {
            const n = _distancia(dominio, d);
            if (n < menor) {
                menor = n;
                dominio = d;
            }
        });
    }
    return dominio !== digitado && DOMINIOS.includes(dominio) ? `${local}@${dominio}` : '';
}

// "Você quis dizer …?" embaixo do campo de e-mail, logo depois de digitar (e ao sair dele), com o botão que troca o texto.
// textos: { quisDizer: "… {0} …", usar }.
export function ligarSugestaoEmail(campo, { textos = {}, classe = 'ent__sug', depoisDe = campo } = {}) {
    const caixa = document.createElement('p');
    caixa.className = classe;
    caixa.hidden = true;
    caixa.setAttribute('aria-live', 'polite');
    const texto = document.createElement('span');
    const botao = document.createElement('button');
    botao.type = 'button';
    botao.className = 'btn btn--sm btn--out';
    botao.textContent = textos.usar || '';
    caixa.append(texto, botao);
    depoisDe.insertAdjacentElement('afterend', caixa);
    let sugestao = '';
    let espera = null;
    const atualizar = () => {
        sugestao = sugerirEmail(campo.value);
        caixa.hidden = !sugestao;
        if (sugestao) {
            const [antes, depois = ''] = (textos.quisDizer || '{0}').split('{0}');
            const b = document.createElement('b');
            b.textContent = sugestao;
            texto.replaceChildren(antes, b, depois);
        }
    };
    campo.addEventListener('input', () => {
        clearTimeout(espera);
        espera = setTimeout(atualizar, 600);
    });
    campo.addEventListener('blur', () => {
        clearTimeout(espera);
        atualizar();
    });
    botao.addEventListener('click', () => {
        campo.value = sugestao;
        campo.dispatchEvent(new Event('input', { bubbles: true }));
        clearTimeout(espera);
        caixa.hidden = true;
        campo.focus();
    });
    return { atualizar };
}

// As telas de hoje põem os textos (resx) no próprio campo, em data-criterios.
export function textosDoCampo(campo) {
    try {
        return JSON.parse(campo?.dataset.criterios || '{}');
    } catch {
        return {};
    }
}

// As classes do Bootstrap das telas de hoje (o v1 não carrega o CSS da v2).
export const CLASSES_BOOTSTRAP = { lista: 'list-unstyled small text-muted mt-2 mb-0', item: 'd-flex align-items-center gap-2', ok: 'text-success', falta: 'text-danger', sr: 'visually-hidden' };

// textos: { tamanho, letra, numero, atendido, falta }. Devolve `marcarFaltas()`, que pinta de erro o que ainda falta (ao tentar
// seguir com a senha fora da regra).
export function ligarCriteriosSenha(campo, { textos = {}, classes = {}, depoisDe = campo } = {}) {
    const c = { lista: 'ent__crit', item: '', ok: 'is-ok', falta: 'is-falta', sr: 'sr', ...classes };
    const lista = document.createElement('ul');
    lista.className = c.lista;
    lista.id = `${campo.id}-criterios`;
    CRITERIOS.forEach(([chave]) => {
        const item = document.createElement('li');
        item.dataset.criterio = chave;
        if (c.item) {
            item.className = c.item;
        }
        item.innerHTML = '<svg viewBox="0 0 16 16" width="14" height="14" fill="currentColor" aria-hidden="true" focusable="false"><path></path></svg>';
        const rotulo = document.createElement('span');
        rotulo.textContent = textos[chave] || '';
        const estado = document.createElement('span');
        estado.className = c.sr;
        item.append(rotulo, estado);
        lista.append(item);
    });
    depoisDe.insertAdjacentElement('afterend', lista);
    const descritos = (campo.getAttribute('aria-describedby') || '').split(' ').filter(Boolean);
    campo.setAttribute('aria-describedby', [...descritos, lista.id].join(' '));

    const atualizar = () => {
        const valor = campo.value || '';
        CRITERIOS.forEach(([chave, atende]) => {
            const item = lista.querySelector(`[data-criterio="${chave}"]`);
            const ok = atende(valor);
            item.classList.toggle(c.ok, ok);
            if (ok) {
                item.classList.remove(c.falta);
            }
            item.querySelector('path').setAttribute('d', ok ? ICONE.ok : ICONE.falta);
            item.lastElementChild.textContent = `: ${ok ? textos.atendido || '' : textos.falta || ''}`;
        });
    };
    campo.addEventListener('input', atualizar);
    atualizar();
    return {
        marcarFaltas() {
            CRITERIOS.forEach(([chave, atende]) => {
                lista.querySelector(`[data-criterio="${chave}"]`).classList.toggle(c.falta, !atende(campo.value || ''));
            });
        },
        atualizar
    };
}
